var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "wrapper" }, [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.mnemonic,
              expression: "mnemonic"
            }
          ],
          class: {
            center: !_vm.mnemonic
          },
          attrs: { placeholder: _vm.$t("mnemonic.placeholder") },
          domProps: { value: _vm.mnemonic },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.mnemonic = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errMsg,
                expression: "errMsg"
              }
            ],
            staticClass: "msg __err_msg"
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.errMsg === "mnemonic.empty" ||
                    _vm.errMsg === "mnemonic.error" ||
                    _vm.errMsg === "hint.nodeErr"
                    ? _vm.$t(_vm.errMsg)
                    : _vm.errMsg
                ) +
                "\n        "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("create", { ref: "createDom", attrs: { submit: _vm.validMnemonic } }),
      _vm._v(" "),
      _c("div", { staticClass: "note" }, [
        _vm._v(_vm._s(_vm.$t("mnemonic.hint")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "__btn_list" }, [
        _c(
          "span",
          {
            staticClass: "__btn __btn_border __pointer",
            on: { click: _vm.leftClick }
          },
          [_vm._v(_vm._s(_vm.$t(_vm.leftTxt)))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "__btn __btn_all_in __pointer",
            on: { click: _vm.valid }
          },
          [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isLoading,
                    expression: "!isLoading"
                  }
                ]
              },
              [_vm._v(_vm._s(_vm.$t("create.finish")))]
            ),
            _vm._v(" "),
            _c("loading", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isLoading,
                  expression: "isLoading"
                }
              ],
              attrs: { loadingType: "dot" }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }